var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoBrndOrg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "BACKGROUND"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#FFFFFF"
    },
    width: 500,
    height: 500
  })), /*#__PURE__*/React.createElement("g", {
    id: "OBJECT"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M421.778,307.045h-250.21c-12.21,0-22.109-9.898-22.109-22.109V117.939 c0-12.21,9.898-22.109,22.109-22.109h250.21c12.21,0,22.109,9.898,22.109,22.109v166.997 C443.887,297.146,433.988,307.045,421.778,307.045z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "#D6D6D6"
    },
    d: "M443.887,127.932H149.458v-9.993c0-12.21,9.898-22.109,22.109-22.109h250.21 c12.21,0,22.109,9.898,22.109,22.109V127.932z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M394.622,116.728H220.446c-2.677,0-4.847-2.17-4.847-4.847l0,0c0-2.677,2.17-4.847,4.847-4.847 h174.177c2.677,0,4.847,2.17,4.847,4.847l0,0C399.47,114.558,397.299,116.728,394.622,116.728z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M170.602,111.881c0,2.187-1.773,3.96-3.96,3.96c-2.187,0-3.96-1.773-3.96-3.96 c0-2.187,1.773-3.96,3.96-3.96C168.829,107.921,170.602,109.694,170.602,111.881z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M185.386,111.881c0,2.187-1.773,3.96-3.96,3.96c-2.187,0-3.96-1.773-3.96-3.96 c0-2.187,1.773-3.96,3.96-3.96C183.613,107.921,185.386,109.694,185.386,111.881z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M199.927,111.881c0,2.187-1.773,3.96-3.96,3.96c-2.187,0-3.96-1.773-3.96-3.96 c0-2.187,1.773-3.96,3.96-3.96C198.154,107.921,199.927,109.694,199.927,111.881z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D6D6D6"
    },
    points: "317.688,174.169 292.794,199.062 267.901,174.169 252.879,189.191 277.773,214.084  252.879,238.977 267.901,253.999 292.794,229.105 317.688,253.999 332.71,238.977 307.816,214.084 332.71,189.19  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1282D6"
    },
    d: "M396.142,383.719H294.18l8.055-115.345c0.48-6.881,6.448-12.459,13.329-12.459h77.045 c6.881,0,12.069,5.578,11.589,12.459L396.142,383.719z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3897E9"
    },
    d: "M381.142,383.719H279.18l8.055-115.345c0.48-6.881,6.448-12.459,13.329-12.459h77.045 c6.881,0,12.069,5.578,11.589,12.459L381.142,383.719z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1282D6"
    },
    d: "M339.822,255.916c3.805,3.545,5.303,6.905,5.932,9.467c1.283,5.233,0.187,12.238,0.184,12.302l0,0 c1.968,2.335,4.475,5.481,7.166,9.354c0,0,6.017,8.661,10.261,17.649c5.288,11.199,13.86,29.352,9.86,48.665 c-3.065,14.798-13.529,30.366-13.529,30.366l0,0h-58.013l7.108-127.818L339.822,255.916z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#262626"
    },
    d: "M231.273,183.562c0.285-0.914,4.952-15.26,15.914-20.145c5.246-2.337,11.159-2.561,11.159-2.561 c0.611-0.023,3.135-0.099,6.535,0.459c0,0,7.846,0.95,13.567,5.006c10.067,7.139,15.901,25.013,14.828,40.558 c-0.382,5.527-1.693,11.204,1.901,15.451c1.939,2.291,5.155,3.052,9.717,4.45c9.478,2.904,25.07,6.573,31.337,19.261 c6.268,12.688,7.032,30.573,2.904,35.465c-4.127,4.892-102.629,4.433-106.117,0.611c-3.488-3.822-9.908-22.318-10.673-36.994 c-0.68-13.045,8.459-18.448,10.673-34.528C234.56,199.397,232.903,189.854,231.273,183.562z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#262626",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M287.467,182.143 c1.889,3.684,4.598,9.625,6.573,17.313c3.12,12.147,0.656,14.085,3.516,18.763c6.35,10.389,20.136,4.045,33.325,15.898 c7.397,6.648,9.959,14.844,10.822,17.733c3.751,12.541,0.252,23.298-1.227,27.182"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#262626",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M234.881,206.449 c-1.846,4.162-4.822,10.751-8.713,18.803c-7.107,14.706-9.09,17.378-8.553,22.622c0.931,9.084,8.678,18.598,8.679,18.598"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FEC02D"
    },
    d: "M249.948,238.344c0,0,25.279,0,25.39,0c20.075,0,42.066,14.368,55.269,28.405 c10.562,11.229,18.291,24.879,24.155,39.136c7.638,18.57,15.117,44.3,5.775,63.518c-1.395,2.869-4.557,9.162-11.263,12.558 c-7.378,3.736-15.086,1.505-17.476,1.505c-15.592,0-153.783,0.042-153.783,0.042c-3.693-35.897,3.422-62.943,8.561-77.698 c4.774-13.709,10.358-29.187,24.931-43.885C225.464,247.85,240.852,241.363,249.948,238.344z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAA418"
    },
    points: "248.792,238.344 231.059,384.129 219.595,384.041 237.353,242.892  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7A99C"
    },
    d: "M262.593,249.073L262.593,249.073c7.112,0.027,12.899-5.716,12.926-12.828l0.105-27.71 l-25.753-0.098l-0.105,27.711C249.739,243.259,255.482,249.046,262.593,249.073z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF7769"
    },
    d: "M249.795,228.391l16.773-8.617c-0.17,1.452-1.123,8.255-7.106,12.953 c-3.82,3-7.834,3.685-9.688,3.879L249.795,228.391z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7A99C"
    },
    d: "M276.249,199.95c0.081-0.419,1.184-1.051,1.523-1.268c0.573-0.366,1.192-0.658,1.839-0.867 c1.257-0.404,2.637-0.498,3.928-0.202c2.568,0.589,4.844,2.746,5.271,5.388c0.248,1.535-0.106,3.122-0.764,4.531 c-0.989,2.118-2.666,3.898-4.692,5.065c-1.679,0.967-3.589,1.514-5.52,1.629c-0.387,0.023-4.344-0.069-4.315-0.22 C274.43,209.321,275.34,204.636,276.249,199.95z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7A99C"
    },
    d: "M279.78,200.218c-0.305,2.068-2.122,12.973-11.951,20.678c-1.811,1.419-13.849,10.855-24.862,6.25 c-14.153-5.917-12.609-29.163-12.509-30.422c0.337-4.256,1.331-16.791,11.712-23.479c8.472-5.458,17.653-3.451,18.955-3.145 c1.372,0.323,10.112,2.528,15.46,11.097C281.437,188.973,280.278,196.835,279.78,200.218z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#262626"
    },
    d: "M238.489,196.74c-0.228,1.815-1.627,3.133-3.126,2.945s-2.528-1.812-2.3-3.627 c0.228-1.815,1.627-3.134,3.126-2.945C237.687,193.302,238.717,194.925,238.489,196.74z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#262626"
    },
    d: "M254.843,198.794c-0.228,1.815-1.627,3.133-3.125,2.945c-1.498-0.188-2.528-1.812-2.3-3.627 c0.228-1.815,1.627-3.133,3.125-2.945C254.041,195.355,255.071,196.979,254.843,198.794z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#262626",
      strokeWidth: 1.3478,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M243.427,199.456l-2.507,3.386c-0.461,0.622-0.288,1.506,0.374,1.909l2.302,1.401"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF7769"
    },
    d: "M260.328,207.342c-0.256,2.036-2.114,3.48-4.15,3.224c-2.036-0.256-3.48-2.114-3.224-4.15 c0.256-2.036,2.114-3.48,4.15-3.224C259.141,203.448,260.584,205.306,260.328,207.342z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#262626",
      strokeWidth: 1.3478,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M277.977,209.262c-0.012-0.408-0.047-3.173,2.172-5.168c1.738-1.563,3.76-1.665,4.312-1.675"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#262626",
      strokeWidth: 1.3478,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M279.934,204.64c0.123-0.019,1.611-0.226,2.649,0.899c0.854,0.924,0.776,2.068,0.76,2.258"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF7769"
    },
    d: "M232.384,201.465c-0.704-0.088-1.382,0.038-1.985,0.31c0.072,1.995,0.264,4.415,0.702,6.982 c0.119,0.027,0.233,0.066,0.357,0.082c2.036,0.256,3.895-1.188,4.15-3.224C235.864,203.579,234.421,201.721,232.384,201.465z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#262626",
      strokeWidth: 1.3478,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M240.02,212.941c0.429-0.521,1.763-2.003,4.07-2.58c2.614-0.653,4.712,0.297,5.274,0.573"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#262626"
    },
    d: "M229.301,190.321h16.204c0,0,0.611-5.274,2.217-7.873s4.051-4.204,4.051-4.204 c-0.368,0.931-0.787,2.164-1.108,3.65c-0.229,1.06-0.534,2.466-0.516,4.299c0,0,0.007,0.694,0.401,4.127h14.064 c-0.323-0.856-1.016-3.036-0.42-5.732c0.52-2.353,1.755-3.903,2.374-4.586c-0.476,4.22,0.058,7.582,0.568,9.707 c0.889,3.705,2.371,6.43,3.478,8.465c1.063,1.955,2.106,3.516,2.907,4.63c0,0,1.909-2.411,3.456-3.348 c1.548-0.937,3.129-1.781,3.129-1.781c0.355-1.843,0.674-4.643,0.177-7.965c-1.022-6.838-4.815-11.306-6.401-12.974 c-5.379-5.658-11.815-6.929-14.159-7.357c-5.001-0.913-9.011-0.151-10.395,0.153c-1.082,0.238-3.593,0.863-6.516,2.389 c-2.028,1.058-7.773,4.14-11.178,10.892C230.827,184.41,229.773,186.953,229.301,190.321z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00AB65"
    },
    d: "M246.518,239.55c0,0-15.688,64.274-17.522,85.828c-1.834,21.554-2.522,58.75-2.522,58.75 l-48.459-0.618c-0.987-6.96-1.87-16.427-1.529-27.635c0.799-26.198,7.796-45.682,10.548-52.739 c6.478-16.615,14.3-36.679,34.624-51.363C231.056,244.984,240.198,241.46,246.518,239.55z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EEF8F2"
    },
    points: "214.55,280.13 194.37,383.719 206.448,383.719  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#262626",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M218.066,261.633 c-1.108,6.231-2.84,16.646-4.389,29.66c-1.897,15.939-1.612,19.763-4.732,60.5c-0.935,12.213-2.497,31.926-2.497,31.926l0,0"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7A99C"
    },
    d: "M262.072,360.576c1.832,1.899,2.888,3.724,3.497,4.987c1.913,3.971,1.979,7.745,2.026,10.414 c0.028,1.59-0.063,2.91-0.153,3.822c0,0-23.694-7.643-27.21-7.338c-3.098,0.269-18.536,4.217-22.165,5.153 c-0.504,0.13-1.029,0.116-1.527-0.037l-5.2-1.6l-4.903,0.209c-1.76,0.075-2.966-1.725-2.249-3.334 c0.178-0.4,0.417-0.835,0.732-1.308c2.14-3.21,4.28-5.503,4.28-5.503l-7.857,1.417c-0.762,0.003-2.01-0.103-2.438-0.867 c-0.638-1.14,0.93-3.063,2.002-4.352c2.487-2.989,5.205-4.597,6.076-5.102c3.07-1.78,5.933-3.44,10.624-4.853 c3.697-1.114,13.877-4.347,26.408-1.166C252.227,353.202,258.257,357.321,262.072,360.576z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF7769"
    },
    d: "M260.819,359.544c0.104,0.802,0.654,5.684-2.855,9.86c-3.911,4.654-9.593,4.539-10.283,4.513 l19.761,5.882c0,0,0.146-7.068-0.203-8.806c-0.349-1.738-1.566-5.752-2.82-7.469 C263.165,361.807,260.819,359.544,260.819,359.544z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#262626",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M211.34,375.977 c2.274-2.488,6.196-6.168,12.013-9.072c5.482-2.737,10.478-3.702,13.745-4.075"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#262626",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M206.437,376.186 c3.585-6.113,7.553-9.293,10.482-11.062c0,0,2.164-1.307,13.529-5.58l0,0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#262626",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M208.843,366.105 c2.883-4.255,5.893-6.231,8.077-7.249c3.884-1.812,9.783-2.751,9.783-2.752l0,0"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00AB65"
    },
    d: "M277.975,238.344c0,0-4.954,36.817-5.642,58.83c-0.688,22.013-1.392,59.618-1.392,59.618 l-8.869,3.784c0,0,4.233,12.497,4.495,16.395c0.263,3.898,0,7.158,0,7.158c12.971-0.253,23.512,0.068,30.759,0.409 c6.165,0.291,15.345,0.347,33.707,0.459c6.529,0.04,12.046,0.01,18.24-3.034c0.733-0.361,6.954-3.5,11.569-9.807 c2.987-4.082,7.675-12.736,5.044-34.166c-1.107-9.017-4.949-37.226-26.828-63.975c-12.5-15.282-24.836-22.691-28.267-24.664 c-10.407-5.982-19.562-8.419-21.463-8.911C284.799,239.271,280.882,238.673,277.975,238.344z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EEF8F2"
    },
    d: "M307.75,308.716c0.236,5.761-0.158,16.1-5.455,27.287c-2.834,5.985-6.275,10.531-9.172,13.751 c6.319-1.628,12.637-3.257,18.956-4.885L307.75,308.716z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#262626",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M333.633,340.054 c0,0-55.346,13.605-62.692,16.739c-7.346,3.134-8.869,3.784-8.869,3.784"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M337.913,282.729 c0,0,27.21,51.21,19.108,72.153c-1.239,3.202-3.976,10.129-10.82,15.161c-6.419,4.718-13.336,5.465-25.256,5.782 c-10.424,0.277-24.288,0.216-40.815-1.07"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#262626",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M329.955,264.093 c-11.226,4.445-16.456,10.437-19.099,14.509c0,0-8.11,12.492,1.881,66.681l0,0"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D3FBDF"
    },
    d: "M264.598,385.003h-74.277v-8.898h78.115v5.06C268.436,383.285,266.718,385.003,264.598,385.003z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D3FBDF"
    },
    d: "M198.45,385.003H95.954c-2.343,0-4.474-1.899-4.761-4.242l-9.307-76.127 c-0.286-2.343,1.381-4.242,3.723-4.242h102.497c2.343,0,4.474,1.899,4.761,4.242l9.306,76.127 C202.46,383.104,200.793,385.003,198.45,385.003z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00AB55"
    },
    d: "M192.45,385.003H89.954c-2.343,0-4.474-1.899-4.761-4.242l-9.307-76.127 c-0.286-2.343,1.381-4.242,3.723-4.242h102.497c2.343,0,4.474,1.899,4.761,4.242l9.306,76.127 C196.46,383.104,194.793,385.003,192.45,385.003z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00AB55"
    },
    d: "M75.886,304.634c0.742-0.203,3.458,23.531,18.969,44.897c2.683,3.695,7.523,10.262,15.745,16.662 c0,0,8.361,6.508,39.516,18.809l0,0c-1.679,0-3.359,0-5.038,0c-4.131,0-8.262,0-12.394,0c-5.229,0-10.458,0-15.687,0 c-4.972,0-9.944,0-14.917,0c-2.668,0-5.335,0.003-8.003,0.002c-2.125-0.001-4.769,0.474-6.666-0.713 c-1.57-0.982-2.256-2.924-2.481-4.762c-0.159-1.301-0.141-2.616-0.287-3.918c-0.145-1.288-0.394-2.566-0.551-3.856 c-0.344-2.816-0.689-5.633-1.033-8.449c-0.563-4.607-1.126-9.213-1.69-13.82c-0.607-4.968-1.215-9.936-1.822-14.903 c-0.564-4.613-1.128-9.226-1.692-13.838c-0.433-3.541-0.802-7.091-1.299-10.625C75.987,306.066,75.705,304.683,75.886,304.634z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#262626",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M85.193,380.761"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#262626",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M89.954,385.003"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#262626",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M192.45,385.003"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#262626",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M79.61,300.392 h102.497c2.343,0,4.474,1.899,4.761,4.242l9.306,76.127"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#262626",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M75.886,304.634"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FEC02D"
    },
    d: "M138.996,340.577c0,3.261-2.643,5.905-5.904,5.905c-3.261,0-5.904-2.644-5.904-5.905 c0-3.261,2.643-5.904,5.904-5.904C136.352,334.672,138.996,337.316,138.996,340.577z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M357.786,262.856 h11.381c4.996,0,8.937,4.248,8.563,9.23l-3.474,46.26"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M163.039,316.429H44.676c-5.776,0-10.459-4.682-10.459-10.459v-78.998 c0-5.776,4.683-10.459,10.459-10.459h118.363c5.776,0,10.459,4.683,10.459,10.459v78.998 C173.498,311.747,168.815,316.429,163.039,316.429z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "#D6D6D6"
    },
    d: "M173.498,231.699H34.217v-4.727c0-5.776,4.683-10.459,10.459-10.459h118.363 c5.776,0,10.459,4.683,10.459,10.459V231.699z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M150.193,226.399H67.798c-1.266,0-2.293-1.027-2.293-2.293l0,0c0-1.266,1.027-2.293,2.293-2.293 h82.395c1.266,0,2.293,1.027,2.293,2.293l0,0C152.486,225.373,151.46,226.399,150.193,226.399z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M44.22,224.106c0,1.035-0.839,1.874-1.873,1.874c-1.035,0-1.874-0.839-1.874-1.874 s0.839-1.873,1.874-1.873C43.381,222.233,44.22,223.072,44.22,224.106z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M51.213,224.106c0,1.035-0.839,1.874-1.874,1.874c-1.035,0-1.873-0.839-1.873-1.874 s0.839-1.873,1.873-1.873C50.374,222.233,51.213,223.072,51.213,224.106z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M58.092,224.106c0,1.035-0.839,1.874-1.873,1.874c-1.035,0-1.874-0.839-1.874-1.874 s0.839-1.873,1.874-1.873C57.253,222.233,58.092,223.072,58.092,224.106z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D6D6D6"
    },
    points: "113.799,253.572 102.023,265.348 90.247,253.572 83.141,260.678 94.917,272.454  83.141,284.229 90.247,291.336 102.023,279.56 113.799,291.336 120.905,284.229 109.129,272.454 120.905,260.678  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#262626",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M163.039,316.429 H44.676c-5.776,0-10.459-4.682-10.459-10.459v-78.998c0-5.776,4.683-10.459,10.459-10.459h118.363 c5.776,0,10.459,4.683,10.459,10.459v78.998C173.498,311.747,168.815,316.429,163.039,316.429z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#FF7129",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 211.852,
    y1: 162.259,
    x2: 227.322,
    y2: 168.677
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#FF7129",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 211.183,
    y1: 145.326,
    x2: 230.763,
    y2: 163.921
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#FF7129",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 228.195,
    y1: 145.05,
    x2: 235.402,
    y2: 160.169
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00AB65"
    },
    d: "M415.545,228.12c1.403-3.678,2.813-6.533,4.231-8.563c1.417-2.03,3.293-3.672,5.627-4.923 c1.364-0.766,2.791-1.327,4.286-1.686c1.492-0.358,2.911-0.799,4.254-1.323c1.341-0.523,2.569-1.216,3.684-2.076 c1.114-0.861,2.016-2.194,2.706-4.003c1.165-3.054,1.138-5.511-0.082-7.369c-1.22-1.858-2.984-3.227-5.289-4.107 c-3.306-1.261-5.932-1.208-7.879,0.155c-1.95,1.364-3.674,3.545-5.174,6.543l-12.063-4.602c1.165-3.054,2.721-5.639,4.671-7.753 c1.948-2.113,4.175-3.692,6.681-4.736c2.504-1.044,5.229-1.54,8.174-1.488c2.943,0.051,5.974,0.672,9.092,1.861 c6.733,2.568,11.524,5.968,14.375,10.197c2.849,4.23,3.098,9.43,0.744,15.603c-0.762,1.996-1.63,3.663-2.605,5.005 c-0.977,1.341-2.102,2.465-3.375,3.372c-1.275,0.906-2.707,1.664-4.295,2.272c-1.59,0.609-3.346,1.188-5.27,1.739 c-1.777,0.537-3.258,1.097-4.444,1.679c-1.187,0.583-2.19,1.291-3.005,2.121c-0.817,0.831-1.497,1.769-2.037,2.812 c-0.542,1.044-1.073,2.252-1.596,3.623L415.545,228.12z M408.287,246.027l4.673-12.251l12.625,4.816l-4.673,12.251 L408.287,246.027z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00AB65"
    },
    d: "M90.018,164.786c-0.894-2.287-1.44-4.196-1.637-5.728c-0.197-1.532-0.019-3.076,0.534-4.633 c0.309-0.925,0.732-1.783,1.272-2.576c0.539-0.791,1.009-1.59,1.41-2.395c0.4-0.804,0.677-1.639,0.831-2.503 c0.153-0.864,0.011-1.858-0.429-2.983c-0.743-1.899-1.785-3.022-3.128-3.369s-2.731-0.239-4.164,0.322 c-2.055,0.804-3.246,1.929-3.574,3.375c-0.328,1.447-0.21,3.177,0.354,5.191l-7.5,2.933c-0.743-1.899-1.108-3.745-1.094-5.538 c0.014-1.792,0.38-3.455,1.099-4.988c0.719-1.532,1.769-2.904,3.15-4.115c1.38-1.21,3.04-2.195,4.979-2.953 c4.186-1.637,7.824-2.076,10.914-1.319c3.089,0.759,5.385,3.056,6.885,6.893c0.485,1.241,0.783,2.375,0.896,3.404 c0.111,1.029,0.063,2.02-0.145,2.973c-0.209,0.953-0.552,1.903-1.031,2.85c-0.479,0.948-1.047,1.951-1.704,3.013 c-0.595,0.993-1.044,1.873-1.348,2.639c-0.303,0.767-0.47,1.514-0.498,2.239c-0.029,0.727,0.051,1.445,0.238,2.152 c0.187,0.709,0.449,1.49,0.782,2.342L90.018,164.786z M94.174,176.099l-2.979-7.616l7.849-3.07l2.979,7.616L94.174,176.099z"
  }))), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FEC02D"
    },
    points: "440.614,383.719 408.711,383.719 406.582,349.754 442.742,349.754  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#94E261"
    },
    d: "M438.414,349.754H410.91v-28.957c0-7.595,6.157-13.752,13.752-13.752l0,0 c7.595,0,13.752,6.157,13.752,13.752V349.754z"
  }), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M438.414,349.754H410.91v-28.957c0-7.595,6.157-13.752,13.752-13.752l0,0 c7.595,0,13.752,6.157,13.752,13.752V349.754z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000057855107458073552910000015815038113570006431_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000057855107458073552910000015815038113570006431_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#262626",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M415.934,311.237c0,3.85-2.311,3.85-2.311,7.701c0,3.852,2.311,3.852,2.311,7.703c0,3.85-2.311,3.85-2.311,7.701 c0,3.853,2.311,3.853,2.311,7.706c0,3.853-2.311,3.853-2.311,7.706"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#262626",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M421.983,307.62c0,4.212-2.528,4.212-2.528,8.424c0,4.213,2.528,4.213,2.528,8.427c0,4.212-2.528,4.212-2.528,8.424 c0,4.215,2.528,4.215,2.528,8.43c0,4.215-2.528,4.215-2.528,8.43"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#262626",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M430.881,307.97c0,4.177-2.507,4.177-2.507,8.354c0,4.178,2.507,4.178,2.507,8.357c0,4.177-2.507,4.177-2.507,8.354 c0,4.18,2.507,4.18,2.507,8.36c0,4.18-2.507,4.18-2.507,8.36"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#262626",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M437.097,313.006c0,3.673-2.205,3.673-2.205,7.347c0,3.675,2.205,3.675,2.205,7.349c0,3.673-2.205,3.673-2.205,7.347 c0,3.676,2.205,3.676,2.205,7.352c0,3.676-2.205,3.676-2.205,7.352"
  })))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAA418"
    },
    d: "M442.742,349.754l-2.128,33.965h-31.903c4.261-1.155,12.646-4.047,20.512-11.445 C438.282,363.753,441.568,354.037,442.742,349.754z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#262626",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M440.913,355.151c-1.295,3.219-3.481,7.65-7.165,12.228c-3.68,4.574-7.537,7.655-10.403,9.609"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoBrndOrg);
export default __webpack_public_path__ + "static/media/no-brnd-org.7dc4d0f2fb78494599cb8725e867d9ea.svg";
export { ForwardRef as ReactComponent };